import React from 'react';
import { colors, font } from '../../lib/tokens';

type EyebrowProps = {
  children: React.ReactNode;
  color?: string;
  /** Swap the leading rule for a pulsing dot — for statements that are live now. */
  live?: boolean;
};

export default function Eyebrow({ children, color = colors.blue, live = false }: EyebrowProps) {
  return (
    <div
      style={{
        fontFamily: font.mono,
        fontSize: 11,
        letterSpacing: 1,
        textTransform: 'uppercase',
        color,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      {live ? (
        <span className="kc-live-dot" aria-hidden />
      ) : (
        <span style={{ width: 14, height: 1, background: color, display: 'inline-block' }} />
      )}
      {children}
    </div>
  );
}
